import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Email } from '@material-ui/icons';
import CommonDialog from './commonDialog';
import LoaderPopUp from '../loaderpopup/loader';

export default function EmailDialog({ row, deleteRow }) {
    const [showDialog, setshowDialog] = useState('');
    const [open, setOpen] = React.useState(true);
    const [showLoader, setShowLoader] = useState(false);

    const handleClickOpen = () => {
        setShowLoader(true);
        setTimeout(() => {
            setOpen(true);
            setshowDialog(true);
        }, 1500);
    };
    const handleClose = () => {
        setOpen(false);
        setShowLoader(false);
    };
    const handleOk = () => {
        setShowLoader(true);
        setTimeout(() => {
            deleteRow(row);
            setOpen(false);
        }, 1500);
    };

    return (
        <>
            {showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} />) : null}
            <Tooltip title="Generate Receipt" row={row} onClick={handleClickOpen}>
                <IconButton aria-label="email">
                    <Email />
                </IconButton>
            </Tooltip>
            {showDialog ? (
                <CommonDialog
                    showDialogBox={open}
                    callClose={handleClose}
                    callConfirmation={handleOk}
                    text="Do you want to generate receipt. On selecting ok an email will be sent to client's email id."
                />
            ) : (
                    ''
                )}
        </>
    );
}
